import api from 'api';
import MenuItem from 'records/MenuItem';

export const MENU_ITEM_ASYNC_ACTION_START = 'MENU_ITEM_ASYNC_ACTION_START';
export const MENU_ITEM_ASYNC_ACTION_ERROR = 'MENU_ITEM_ASYNC_ACTION_ERROR';
export const MENU_ITEM_ASYNC_UPDATE_ACTION_SUCCESS = 'MENU_ITEM_ASYNC_UPDATE_ACTION_SUCCESS';
export const MENU_ITEM_UPDATE_ACTION_SUCCESS = 'MENU_ITEM_UPDATE_ACTION_SUCCESS';
export const MENU_ITEM_ARCHIVE_ACTION_SUCCESS = 'MENU_ITEM_ARCHIVE_ACTION_SUCCESS';
export const MENU_ITEM_RESET_STATE = 'MENU_ITEM_RESET_STATE';

function menuItemAsyncActionStart() {
  return {
    type: MENU_ITEM_ASYNC_ACTION_START,
  };
}

function menuItemAsyncActionError(error) {
  return {
    type: MENU_ITEM_ASYNC_ACTION_ERROR,
    error,
  };
}

function menuItemAsyncUpdateSuccess(data) {
  return {
    type: MENU_ITEM_ASYNC_UPDATE_ACTION_SUCCESS,
    data,
  };
}

function menuItemAsyncArchiveSuccess() {
  return {
    type: MENU_ITEM_ARCHIVE_ACTION_SUCCESS,
  };
}

export function resetMenuItemState() {
  return {
    type: MENU_ITEM_RESET_STATE,
  };
}

export function updateMenuItem(data) {
  return {
    type: MENU_ITEM_UPDATE_ACTION_SUCCESS,
    data,
  };
}

export function getMenuItemAsync(id) {
  return (dispatch, getState) => {
    dispatch(menuItemAsyncActionStart());
    return api.request(`menuItem/${ id }`, 'get')
    .then((data) => {
      dispatch(menuItemAsyncUpdateSuccess(data));
      return new MenuItem(data);
    })
    .catch((err) => {
      dispatch(menuItemAsyncActionError('Unable to get menu item'));
      throw (err);
    });
  };
}

export function createMenuItemAsync(menuItem) {
  return (dispatch, getState) => {
    dispatch(menuItemAsyncActionStart());
    return api.request('menuItem', 'post', menuItem, api.contentTypes.form)
    .then((data) => {
      dispatch(menuItemAsyncUpdateSuccess(data));
      return new MenuItem(data);
    })
    .catch((err) => {
      dispatch(menuItemAsyncActionError('Unable to create menu item'));
      throw (err);
    });
  };
}

export function updateMenuItemAsync(menuItem) {
  return (dispatch, getState) => {
    dispatch(menuItemAsyncActionStart());
    return api.request('menuItem', 'put', menuItem, api.contentTypes.form)
    .then((data) => {
      dispatch(menuItemAsyncUpdateSuccess(data));
      return new MenuItem(data);
    })
    .catch((err) => {
      dispatch(menuItemAsyncActionError('Unable to update menu item'));
      throw (err);
    });
  };
}

export function updateMenuItemOverridedAsync(menuItemId, overrided) {
  return (dispatch, getState) => {
    dispatch(menuItemAsyncActionStart());
    return api.request(`menuItem/updateOverrided/${menuItemId}/${overrided}`, 'put')
    .then((data) => {
      dispatch(menuItemAsyncUpdateSuccess(data));
      return new MenuItem(data);
    })
    .catch((err) => {
      dispatch(menuItemAsyncActionError('Unable to update menu item overrided'));
      throw (err);
    });
  };
}

export function archiveMenuItemAsync(id) {
  return (dispatch, getState) => {
    dispatch(menuItemAsyncActionStart());
    return api.request(`menuItem/archive/${ id }`, 'post')
    .then((data) => {
      dispatch(menuItemAsyncArchiveSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(menuItemAsyncActionError('Unable to archive menu item'));
      throw (err);
    });
  };
}

export function restoreArchiveMenuItemAsync(menuItemId, userCategoryId) {
  return (dispatch, getState) => {
    dispatch(menuItemAsyncActionStart());
    return api.request(`menuItem/restoreArchive/${ menuItemId }?userCategoryId=${ userCategoryId }`, 'post')
    .then((data) => {
      dispatch(menuItemAsyncArchiveSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(menuItemAsyncActionError('Unable to restore archived menu item'));
      throw (err);
    });
  };
}

export function updateLinkRecipeMenuitemAsync(formData) {
  return (dispatch, getState) => {
    dispatch(menuItemAsyncActionStart());
    return api.request('menuItem/updateLinkedRecipe', 'put', formData)
    .then((data) => {
      dispatch(menuItemAsyncUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(menuItemAsyncActionError('Unable to update menu item to recipe linked status'));
      throw (err);
    });
  };
}
